import React from 'react';
import { TableRow, TableCell, Typography } from '@mui/material';

function CategoryRow({ category }) {
    return (
        <TableRow>
            <TableCell
                colSpan={3}
                sx={{
                    backgroundColor: 'grey.100',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    py: 0.75,
                    px: 2,
                }}
            >
                <Typography variant="heavy" sx={{ fontSize: '12px', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    {category || 'Uncategorized'}
                </Typography>
            </TableCell>
        </TableRow>
    );
}

export default CategoryRow;
